import { useNavigate } from "react-router-dom";
import { Editable } from "@/components/Editable";
import { ImageEditArea } from "@/components/ImageEditArea";
import { LinkEditButton } from "@/components/LinkEditButton";
import { CraneMark } from "@/components/CraneMark";
import { ModalityIconSlot } from "@/components/ModalityIconSlot";
import { SealEditor } from "@/components/SealEditor";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

export default function Home() {
  const { content } = useContent();
  const navigate = useNavigate();

  if (!content) return null;

  return (
    <main id="page-home">
      <ImageEditArea path="images.hero" id="top" className="hero" label="Change background" testId={CMS.heroImageEdit}>
        <div className="hero-overlay" />
        <div className="wrap hero-grid">
          <div>
            <Editable path="hero.eyebrow" tag="span" className="eyebrow" />
            <h1>
              <Editable path="hero.headline1" tag="span" />
              <br />
              <Editable path="hero.headlineEm" tag="em" />
            </h1>
            <Editable path="hero.lede" tag="p" className="lede" />
            <div className="btn-row">
              <a href={content.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <Editable path="hero.ctaPrimaryText" />
              </a>
              <LinkEditButton path="link" title="Where should 'Book a Consultation' buttons link to?" testId={CMS.bookingLinkEdit} />
              <a
                className="btn btn-secondary"
                onClick={() => document.getElementById("modalities")?.scrollIntoView({ behavior: "smooth" })}
              >
                <Editable path="hero.ctaSecondaryText" />
              </a>
            </div>
          </div>
          <SealEditor />
        </div>
      </ImageEditArea>

      <hr className="divider" />

      <section className="modalities" id="modalities">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow">Five practices, one approach</span>
            <Editable path="modSection.heading" tag="h2" />
            <Editable path="modSection.sub" tag="p" />
          </div>
          <div className="mod-grid">
            {content.modalities.map((m, i) => (
              <div className="mod-card" key={m.slug}>
                <ModalityIconSlot index={i} />
                <Editable path={`modalities.${i}.title`} tag="h3" />
                <Editable path={`modalities.${i}.zh`} tag="span" className="zh" />
                <Editable path={`modalities.${i}.desc`} tag="p" />
                <a className="more" onClick={() => navigate(`/practice/${m.slug}`)} data-testid={`${CMS.modLearnMore}-${m.slug}`}>
                  Learn more
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ImageEditArea path="images.about" id="about" className="about" label="Change background" testId={CMS.aboutImageEdit}>
        <div className="about-overlay" />
        <div className="wrap">
          <div className="about-media">
            <CraneMark viewBox="150 65 170 110" className="about-crane-icon" />
            <ImageEditArea
              path="images.aboutPortrait"
              className="portrait-frame"
              label="Change portrait"
              testId={CMS.portraitImageEdit}
            />
          </div>
          <div>
            <span className="eyebrow">Your practitioner</span>
            <Editable path="about.heading" tag="h2" />
            <Editable path="about.quote" tag="blockquote" />
          </div>
        </div>
      </ImageEditArea>

      <section className="cta-band">
        <div className="wrap">
          <Editable path="cta.heading" tag="h2" />
          <Editable path="cta.text" tag="p" />
          <a href={content.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            <Editable path="cta.buttonText" />
          </a>
          <LinkEditButton path="link" title="Where should 'Book a Consultation' buttons link to?" testId={`${CMS.bookingLinkEdit}-cta`} />
        </div>
      </section>
    </main>
  );
}
